import { logout } from '@/services/api';
import { LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { useModel, history } from '@umijs/max';
import { Avatar, Dropdown, Spin } from 'antd';
import type { MenuProps } from 'antd';
import React, { useCallback } from 'react';

export const AvatarDropdown: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { initialState, setInitialState } = useModel('@@initialState');

  const onMenuClick = useCallback(
    async (event: { key: string }) => {
      const { key } = event;
      if (key === 'logout') {
        await logout();
        localStorage.removeItem('token');
        setInitialState((s) => ({ ...s, currentUser: undefined }));
        history.push('/user/login');
        return;
      }
      if (key === 'settings') {
        history.push('/settings');
      }
    },
    [setInitialState],
  );

  const loading = (
    <span>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuItems: MenuProps['items'] = [
    {
      key: 'user',
      icon: <UserOutlined />,
      label: currentUser.name,
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: 'Settings',
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
    },
  ];

  return (
    <Dropdown menu={{ items: menuItems, onClick: onMenuClick }}>
      {children || (
        <span style={{ cursor: 'pointer' }}>
          <Avatar size="small" src={currentUser.avatar} alt="avatar" />
          <span style={{ marginLeft: 8 }}>{currentUser.name}</span>
        </span>
      )}
    </Dropdown>
  );
};

